import { FETCH_LIST } from './types';

export default {
  [FETCH_LIST]: (state, payload) => {
    state.items = payload.items;
  },
};
